module.exports = __webpack_public_path__ + "static/media/complete-status_ar.990332c6.svg";